import React from "react";
import PropTypes from "prop-types";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import EditableField from "./editableField";

const GenderField = ({ value, isEditing, onEdit, onSave, onCancel, onChange }) => {
  return (
    <EditableField
      label="Género"
      value={value}
      isEditing={isEditing}
      onEdit={onEdit}
      onSave={onSave}
      onCancel={onCancel}
    >
      <Select value={value} onChange={(event) => onChange(event.target.value)} fullWidth>
        <MenuItem value="Masculino">Masculino</MenuItem>
        <MenuItem value="Femenino">Femenino</MenuItem>
        <MenuItem value="Otro">Otro</MenuItem>
      </Select>
    </EditableField>
  );
};

GenderField.propTypes = {
  value: PropTypes.string,
  isEditing: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default GenderField;
